export default {
  Copyright__ALL_RIGHTS_RESERVED: "All Rights Reserved.",
  Copyright__GLOBAL_HEADER_MOBILE_COPYRIGHT: (data) => `®${data.year} Southwest Airlines Co.`,
};
